<template>
    <div class="app-confirm-birthdate">
      <slot name="txtBefore">
        <p>
          Zur Bestätigung Ihrer E-Mailadresse geben Sie bitte noch Ihr Geburtsdatum an und kicken Sie dann auf absenden
        </p>
      </slot>
      <b-form
        :id="'form' + _uid"
        :novalidate="true"
        data-confirm-birthdate
        @keyup.enter.down="next()"
      >
        <b-form-group class="birthdate-group mandatory" :class="vflowGetFeedbackClasses('birthdate')">
          <label for="birthDate" class="mandatory">
            <slot name="lblBirthdate">Geburtsdatum</slot>
          </label>
          <b-form-input
            id="birthDate"
            :key="'birthDateInputField' + refreshKeyBirthDate"
            :value="getBirthdate()"
            @blur="vflowInputBlurred('birthdate'); blurredBirthdate()"
            @click="clickedBirthdate"
            @focus="vflowInputFocused('birthdate'); birthdateError = false"
            @input.native="handleInputBirthdate"
            @keydown="keypressBirthdate"
            aria-describedby="birthdate-live-feedback"
            autocomplete="off"
            class="date-type-assisted"
            name="birthDate"
            placeholder="TT.MM.JJJJ"
            ref="birthDateInputField"
            required
            type="text"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="(!$v.birthdate.hasValidDateFormat || !$v.birthdate.isPassedDate)">
            <slot name="txtInvalidBirthDateLiveFeedback">Dies ist kein gültiges Datum.</slot>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>
      <div class="error-box" v-if="birthdateError && !vflowIsAnyInputFocused()">
        <slot name="txtInvalidBirthDateError">Ufff! Das eingegebene Geburtsdatum ist leider ungültig. Bitte überprüfe deine Eingabe. (Fehler: 1015).</slot>
      </div>
      <Stepper
        :show-prev="false"
        @next="next()"
        :loading-next="loading"
      >
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import validationFlow from '@/mixins/validators/validationFlow'
import date from '@/mixins/validators/date'
import isValid from '@/mixins/validators/isValid'
import Stepper from '@/components/generic/Stepper.vue'
export const stepName = 'confirmBirthdate'

export default {
  name: 'ConfirmBirthdate',
  components: {
    Stepper
  },
  data () {
    return {
      birthdate: '',
      loading: false,
      refreshKeyBirthDate: 0,
      updateBirthDate: false,
      birthdateError: false
    }
  },
  mounted () {
    this.formatBirthdate(this.birthdate)
    this.$v.$reset()
  },
  mixins: [
    validationMixin,
    isValid,
    validationFlow,
    date
  ],
  methods: {
    setCursorPosition (el, pos) {
      el.focus()
      el.setSelectionRange(pos, pos)
    },
    isFormatableDate (v) {
      // replace all invalid characters
      const dv = (v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        return true
      }

      return false
    },
    formatDateExpression (v, event) {
      // replace all invalid characters
      const dv = (v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        const inpDay = (typeof m[1] !== 'undefined' ? m[1] : null)
        const dotDay = (typeof m[2] !== 'undefined' ? (m[2] === '.') : false)
        const inpMonth = (typeof m[3] !== 'undefined' ? m[3] : null)
        const dotMonth = (typeof m[4] !== 'undefined' ? (m[4] === '.') : false)
        const inpYear = (typeof m[5] !== 'undefined' ? m[5] : null)

        const day = parseInt(inpDay)
        const month = parseInt(inpMonth)

        const dayComplete = inpDay !== null && (inpDay.length === 2 || dotDay || parseInt(inpDay.substr(0, 1)) > 3)
        const monthComplete = inpMonth !== null && (dayComplete && (inpMonth.length === 2 || dotMonth || parseInt(inpMonth.substr(0, 1)) > 1))

        let de = ''
        if (dayComplete) {
          de = (day < 10 ? '0' + day.toString() : day) + '.'
        } else {
          de = (inpDay !== null ? inpDay : '')
        }

        if (monthComplete) {
          de = de + (month < 10 ? '0' + month.toString() : month) + '.'
        } else {
          de = de + (inpMonth !== null ? inpMonth : '')
        }

        de = de + (inpYear !== null ? inpYear : '')

        return de
      }

      return v
    },
    filterDateInput (e) {
      const keyCode = e.which || e.code
      let key = e.key
      const validKeyCodes = [
        37, // ArrowLeft
        39, // ArrowRight
        8, // Backspace
        46, // Delete
        36, // Home
        35, // End
        9 // Tab
      ]

      // if we are on android
      if (key === 'Unidentified') {
        return false
      }

      if (!key) {
        key = String.fromCharCode(keyCode)
      }

      if (!/[0-9.]/.test(key) && validKeyCodes.indexOf(keyCode) === -1) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    handleBirthdateKeypress (v, e, startPos) {
      this.filterDateInput(e)
      if (e.key === '.') {
        const afterDotResult = v.substring(0, startPos) + '.' + v.substring(startPos)
        const numDots = (v.match(/\./g) || []).length
        let prevent = (afterDotResult.indexOf('..') !== -1 || numDots > 2)

        // check if user will be between dots
        if (prevent && numDots === 1) {
          if (v.substring(startPos + 1, startPos) === '.') {
            prevent = false
          }
        }

        if (prevent) {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      }
    },
    keypressBirthdate (e) {
      this.handleBirthdateKeypress(this.birthdate, e, this.$refs.birthDateInputField.selectionStart)
      const triggerKeys = ['Home', 'End', 'Tab']
      if (triggerKeys.indexOf(e.key) !== -1) {
        this.updateBirthDate = true
        this.formatBirthdate(this.birthdate)
      }
    },
    handleInputBirthdate (e) {
      if (/[^0-9.]+/.test(e.target.value)) {
        const v = e.target.value.replace(/([^0-9.])/g, '').trim()
        setTimeout(() => {
          this.birthdate = v
          this.formatBirthdate(this.birthdate)
          this.blurredBirthdate()
          this.$nextTick(() => {
            this.$refs.birthDateInputField.$el.focus()
          })
        }, 250)
      } else {
        this.formatBirthdate(e.target.value)
      }
    },
    clickedBirthdate (e) {
      const startPos = this.$refs.birthDateInputField.selectionStart
      if (startPos >= this.birthdate.length) {
        this.formatBirthdate(this.birthdate)
      }
    },
    blurredBirthdate () {
      this.refreshKeyBirthDate += 1
      this.formatBirthdate(this.birthdate)
    },
    formatBirthdate (v) {
      const force = this.vflowIsBlurred('birthdate')
      const startPos = this.$refs.birthDateInputField.selectionStart
      const update = (this.isFormatableDate(v) && (this.updateBirthDate || force || startPos >= v.length))
      if (update) {
        this.$nextTick(() => {
          this.updateBirthDate = false
          this.birthdate = this.formatDateExpression(v)
          this.$v.birthdate.$touch()
        })
      } else {
        this.birthdate = v
        this.$v.birthdate.$touch()
      }
    },
    getBirthdate () {
      return this.birthdate
    },
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    ...mapActions('emailConfirmation', [
      'confirmBirthdate'
    ]),
    next () {
      this.vflowForceFeedback()
      if (!this.$v.$error && !this.$v.$invalid) {
        this.loading = true
        this.confirmBirthdate({ birthdate: this.birthdate }).then((response) => {
          if (response === 'birthdateInvalid') {
            this.birthdateError = true
          }
          this.loading = false
        }, () => {
          this.loading = false
        })
      } else {
        // ensure live feedback for validation errors
        this.vFlowScrollToFirstElemment()
      }
    }
  },
  validations () {
    return {
      birthdate: {
        required,
        hasValidDateFormat (v) {
          return this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v))
        },
        hasValidDate (v) {
          return this.validDate(this.formatDateExpression(v))
        },
        isPassedDate (v) {
          if (typeof v !== 'undefined' && v !== '' && this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v)) && v !== null) {
            return this.validGivenAge(v, 0)
          }

          return true
        }
      }
    }
  }
}
</script>
